import * as React from "react";
import { useSelector } from "react-redux";
import { Box, IconButton } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";

import TableHead, { COLUMNS } from "./TableHead";
import TableBody from "./TableBody";

import {
  FilterAutocomplete,
  PaginationWithLimit,
  ContainerWithLoader,
} from "../../../../components/ui";
import { useComplianceSearchContext } from "../../../../context";

import { StyledHorizontalScrollDiv, StyledTable } from "../../../../useGeneralStyles";
import copyToClipboardInXlsFormat from "../../../../utils/copyToClipboardInXlsFormat";
import { getSelectedRowsData } from "../../utils";

const AccountsTable = (): React.ReactElement => {
  const { accounts_table } = useComplianceSearchContext();

  const { data, loading } = useSelector((state) => state.complianceSearch.accounts_table);

  const handleCopyToClipBoard = () => {
    const rowsData = accounts_table.selectedRows.length
      ? getSelectedRowsData(accounts_table.selectedRows, data.rows)
      : data.rows;
    copyToClipboardInXlsFormat({
      data: rowsData,
      columns: COLUMNS,
      table_name: "E2T Accounts Investigation - Accounts",
    });
  };

  return (
    <div>
      <FilterAutocomplete
        search={accounts_table.search}
        setSearch={accounts_table.setSearch}
        filters={{
          "Account ID": "id",
          Email: "email",
          Name: "name",
          RegIp: "reg_ip",
          Phone: "phone",
          Country: "country",
          Zip: "zip",
          City: "city",
          Address: "address",
          Joined: "joined",
          "Name on card": "payment_card_name",
          "Card address": "payment_card_address",
        }}
        inputTypes={{
          Joined: "date",
        }}
      />

      <StyledHorizontalScrollDiv sx={{ marginTop: 5 }}>
        <div>
          <IconButton size="small" onClick={handleCopyToClipBoard}>
            <FileCopyIcon fontSize="inherit" />
          </IconButton>
          <span>
            Users found: <b>{data.count}. </b>
            {!!accounts_table.selectedRows.length && (
              <>
                Selected: <b>{accounts_table.selectedRows.length}</b>
              </>
            )}
          </span>
        </div>
        <ContainerWithLoader isLoading={loading} report={data.rows}>
          <Box height="30vh" overflow="scroll">
            <StyledTable smTable noTextWrap tableWithoutHover>
              <TableHead />
              <TableBody />
            </StyledTable>
          </Box>

          <PaginationWithLimit
            limit={accounts_table.pagination.limit}
            setLimit={accounts_table.pagination.setLimit}
            page={accounts_table.pagination.page}
            setPageState={accounts_table.pagination.setPage}
            count={data.count}
          />
        </ContainerWithLoader>
      </StyledHorizontalScrollDiv>
    </div>
  );
};

export default AccountsTable;
